import React from 'react';
import { EmptyCollection } from './EmptyCollection';
import { Button } from 'components/Button/Button';
import { Link } from 'react-router-dom';
import egg1 from '../../assets/img/egg/egg1.jpg';
import egg2 from '../../assets/img/egg/egg2.jpg';
import egg3 from '../../assets/img/egg/egg3.jpg';
import egg4 from '../../assets/img/egg/egg4.jpg';
import egg5 from '../../assets/img/egg/egg5.jpg';
import { useEggContext } from 'contexts/EggContext';
import './EggCollection.scss';
import { routes } from '../../routing/routes';
import { SelectableEggCardProfile } from 'components/SelectableCard/Variants/SelectableCardEgg';
import { FLAGS, useFlags } from 'hooks/useFlags';

export function EggCollection() {
  const { data } = useEggContext();
  const eggs = data?.eggs;
  const { isFlagEnabled } = useFlags();

  const eggPlaceholder = [egg1, egg2, egg3, egg4, egg5];

  return (
    <div className="breaker-collection account-egg-collection mt-3">
      {eggs && eggs.length === 0 ? (
        <div className="mt-5">
          <EmptyCollection
            title="Egg Mint is live right now!"
            message="You don’t own any Eggs yet."
            placeholderImages={eggPlaceholder}
          >
            <Link className="nav-link text-center" to={routes.mint()}>
              <Button primary>Mint your egg now</Button>
            </Link>
          </EmptyCollection>
        </div>
      ) : (
        <div>
          <div className="d-flex justify-content-between">
            <div>
              {eggs && <h2>You own {eggs.length} Egg(s)</h2>}
              {!isFlagEnabled(FLAGS.hatchening) && (
                <p>
                  You can level up and manage your eggs{' '}
                  <Link className="text-highlight" to={routes.dashboard()}>
                    here{' '}
                  </Link>
                  .
                </p>
              )}
            </div>
            <div>
              {isFlagEnabled(FLAGS.hatchening) ? (
                <Link className="nav-link" to={routes.hatchening()}>
                  <Button small primary>
                    Hatch Eggs
                  </Button>
                </Link>
              ) : (
                <Link className="nav-link" to={routes.dashboard()}>
                  <Button small primary>
                    Manage eggs
                  </Button>
                </Link>
              )}
            </div>
          </div>
          {eggs && (
            <div className="account-egg-grid">
              {eggs.map((egg) => (
                <SelectableEggCardProfile
                  card={SelectableEggCardProfile.transformer(egg)}
                  key={egg.id}
                />
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
